// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bJP4","content":"styles_content__jieZY"};